import { spec, specTrack } from './spec';
import {
  createSignal,
  createEffect,
  createContext,
  useContext,
  onMount,
  on,
  unwrap,
} from 'solid-js';
import { assign, set } from 'radash';
import { theme_schema } from 'schemas';
import { create } from 'domain';

const kebabize = (str) =>
  str.replace(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    ($, ofs) => (ofs ? '-' : '') + $.toLowerCase(),
  );

  // Convert integer numbers to CSS px strings; leave others as strings
  const toCssValue = (v: any) =>
    typeof v === 'number' && Number.isInteger(v) ? `${v}px` : String(v);

const themeglob = import.meta.glob('../css/*/*');

const ThemeContext = createContext();
export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = (props) => {
  const [theme, setTheme] = createSignal({});
  const [overrides, setOverrides] = createSignal({});
  const [preset, setPreset] = createSignal({});

  const updatePreset = (specPreset = 'default') => {
    const presets = `../css/${specPreset}/presets.json`;
    themeglob[presets]().then(({ default: p }) => {
      setPreset({ ...p });
    });
  };
  createEffect(
    on([() => specTrack(props.theme.preset)], () => {
      updatePreset(props.theme.preset);
    }),
  );
  createEffect(() => {
    setTheme({ ...preset(), ...overrides() });
    const r = document.querySelector('body').style;
    for (let key in theme()) {
      for (let subkey in theme()[key]) {
        const prop = '--' + key + '-' + kebabize(subkey);
        r.setProperty(prop, toCssValue(theme()[key][subkey]));
      }
    }
  });
  createEffect(
    on([() => specTrack(props.theme.style)], () => {
      setOverrides(props.theme.style);
      setTheme({ ...preset(), ...overrides() });
    }),
  );

  return (
    <ThemeContext.Provider value={theme}>
      {props.children}
    </ThemeContext.Provider>
  );
};
